import { render, staticRenderFns } from "./ResidentTabs.vue?vue&type=template&id=f9ae07fa&scoped=true&"
import script from "./ResidentTabs.vue?vue&type=script&lang=ts&"
export * from "./ResidentTabs.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9ae07fa",
  null
  
)

export default component.exports